import React from 'react';

import { CATEGORY_TYPE_CONCEPTUAL } from 'scenes/GalleryTags/abstract/gallery-tags-constants';
import { useLoadCategory } from 'scenes/GalleryTags/data';
import {
  useCreateCategory,
  useEditCategory,
} from 'scenes/GalleryTags/data/mutations';

import CategoryForm from './CategoryForm';

const INITIAL_CATEGORY = {
  type: CATEGORY_TYPE_CONCEPTUAL,
  isMultiselect: true,
  name: '',
  tags: [],
  banner: 'optional',
  gif: 'optional',
  video: 'optional',
  cinemagraph: 'optional',
  playable: 'optional',
};

export const CategoryFormCreate = ({ onExited, onClose, onSubmit, open }) => {
  const [createCategory, { isLoading }] = useCreateCategory();

  const handleSubmit = async (values, _imperativeMethods, meta) => {
    createCategory({
      ...values,
      ...meta,
    }).then(onSubmit);
  };

  return (
    <CategoryForm
      title={'Add Tags Category'}
      initialValues={INITIAL_CATEGORY}
      loading={isLoading}
      onSubmit={handleSubmit}
      onExited={onExited}
      onClose={onClose}
      open={open}
    />
  );
};

export const CategoryFormEdit = ({ id, onExited, onClose, onSubmit, open }) => {
  const { data, isLoading } = useLoadCategory(id);
  const [editCategory, { isLoading: isEditing }] = useEditCategory();

  const handleSubmit = async (values, _imperativeMethods, meta) => {
    return editCategory({
      ...values,
      ...meta,
    }).then(category => onSubmit(category));
  };

  return (
    <CategoryForm
      title={'Edit Tag Category'}
      initialValues={data}
      loading={isEditing || isLoading}
      active={!!data}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      onExited={onExited}
      onClose={onClose}
      open={open}
    />
  );
};
